/* eslint-disable */
import { defineStore } from "pinia";
import { ref } from "vue";
import axios from "axios";
import pinia from "./index";
import { TextBoxEntryApiModel } from "api-models";

const useSmartTextBoxStore = defineStore("smart-text-box-store", () => {
  const textBoxes = ref<{ [x: string]: Promise<string> }>({});
  const version = ref(0);
  return { textBoxes, version };
});

const smartTextBoxStore = useSmartTextBoxStore(pinia());

export async function getTextBox(uid: string): Promise<string> {
  let promise = smartTextBoxStore.$state.textBoxes[uid];
  if (promise !== undefined) {
    return await smartTextBoxStore.$state.textBoxes[uid];
  }

  let loaded = await axios.get(`/api/textboxentry/${uid}`);
  let data = loaded.data as TextBoxEntryApiModel[];
  let entry = data[0];
  if (entry) {
    return entry.text;
  }
  return "";
}

export async function saveTextBox(
  model: TextBoxEntryApiModel,
  rerunPrompts: boolean,
): Promise<void> {
  smartTextBoxStore.$state.textBoxes[model.cmsUid] = Promise.resolve(model.text);
  if (rerunPrompts) {
    smartTextBoxStore.$state.version++;
  }
  await axios.post(`/api/textboxentry`, model);
}

export default smartTextBoxStore;
